export default "__VITE_ASSET__fe48588b__"